import { render } from "./Unilevel.vue?vue&type=template&id=5a18973f"
import script from "./Unilevel.vue?vue&type=script&lang=ts"
export * from "./Unilevel.vue?vue&type=script&lang=ts"
script.render = render

export default script